import router from "./routers"
import NProgress from "nprogress"       // progress bar
import "nprogress/nprogress.css"        // progress bar style
import { getToken } from "@/utils/auth" // getToken from cookie
import { domTitle, setDocumentTitle } from "@/utils/domUtil"

NProgress.configure({ showSpinner: false })// NProgress Configuration

const whiteList = ["/login"]// no redirect whitelist
const loginRoutePath = "/login"
const defaultRoutePath = '/'

router.beforeEach((to, from, next) => {
  NProgress.start()
  to.meta && typeof to.meta.title !== 'undefined' && setDocumentTitle(`${to.meta.title} - ${domTitle}`)
  if (getToken()) {
    // 已登录且要跳转的页面是登录页
    if (to.path === loginRoutePath) {
      next({ path: defaultRoutePath })
      NProgress.done()
    } else {
      next()
    }
  } else {
    /* 未登录 */
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
